import { JcDTO } from "./JcDTO";

export abstract class JcModel<T extends JcDTO> {
    protected constructor(public readonly id: string) { }
    abstract toDTO(): T;
}